<template>
  <div class="plv-ia-lottery-card">
    <div class="plv-ia-lottery-card-list" @scroll="scrollLoader">
      <div class="plv-ia-lottery-card-list-item" v-for="(item, index) in lotteryCardList" :key="index">
        <div class="plv-ia-lottery-card-item-left">
          <div class="plv-ia-lottery-card-item-header">
            <span v-if="item.status === 'start' || item.status === 'lottery'"
                  class="plv-ia-lottery-card-item-status plv-ia-lottery-card-item-status--start"
            >{{t(`plvIA.lottery.inProgress`)}}</span>
            <span v-else-if="item.status === 'wait'"
                  class="plv-ia-lottery-card-item-status plv-ia-lottery-card-item-status--waiting"
            >{{t(`plvIA.lottery.notStarted`)}}</span>
            <span v-else-if="item.status === 'cancel'"
                  class="plv-ia-lottery-card-item-status plv-ia-lottery-card-item-status--waiting"
            >{{t(`plvIA.lottery.statusCancel`)}}</span>
            <span v-else-if="item.status === 'end' || item.status === 'finish'"
                  class="plv-ia-lottery-card-item-status plv-ia-lottery-card-item-status--end"
            >{{t(`plvIA.lottery.theEnd`)}}</span>

            <span class="plv-ia-lottery-card-item-header-title"> {{item.activeName}}</span>
          </div>
          <div class="plv-ia-lottery-card-item-msg">
            {{ t('plvIA.lottery.prizeName') }}{{item.prizeName}}
          </div>
          <div class="plv-ia-lottery-card-item-msg">
            {{ t('plvIA.lottery.numberWinners') }}{{item.amount}}
          </div>
          <div class="plv-ia-lottery-card-item-msg">
            {{ t('plvIA.lottery.lotteryMethod') }}{{ conditionTypeMean(item.conditionType) }}
          </div>
          <div v-if="item.conditionType !== 'none'" class="plv-ia-lottery-card-item-msg">
            {{ t('plvIA.lottery.activityDuration') }}{{ item.activityDuration }}min
          </div>
          <div v-else class="plv-ia-lottery-card-item-msg">
            {{ t('plvIA.lottery.drawTime') }}{{ formatData(item.lotteryTime) }}
          </div>
        </div>
        <!-- 抽奖倒计时-->
        <div v-if="item.status !== 'cancel'" class="plv-ia-lottery-card-item-right">
          <div v-if="item.status === 'wait'" class="plv-ia-lottery-card-item-delayTime">
            <!--  中英文显示-->
            <Countdown :delayTime="item.startCountdown" v-slot="{ countdown }" @countdown-finish="waitCountdownFinish(item, 'lottery')">
              <template v-if="lang === 'en'">
                There is still time until the event starts: {{countdown.hour}}:{{countdown.min}}:{{countdown.second}}
              </template>
              <template v-else>
                距活动开始：
                <span>{{countdown.hour}}</span>
                时
                <span>{{countdown.min}}</span>
                分
                <span>{{countdown.second}}</span>
                秒
              </template>
            </Countdown>
          </div>
          <div v-else-if="item.status === 'start'" class="plv-ia-lottery-card-item-duration">
            <Countdown :delayTime="item.lotteryCountdown" v-slot="{ countdown }">
              <template v-if="lang === 'en'">
                Ends in  {{countdown.hour}}:{{countdown.min}}:{{countdown.second}}
              </template>
              <template v-else>
                {{countdown.hour}}时{{countdown.min}}分{{countdown.second}}秒后结束
              </template>
            </Countdown>
          </div>
          <div v-else class="plv-ia-lottery-card-item-duration">
            {{ item.status !== 'lottery' ? t(`plvIA.lottery.activeOver`) : '' }}
          </div>
          <div class="plv-ia-lottery-card-item-control">
            <Confirm v-if="item.status === 'wait'"  :lang="lang"  @confirm="lotteryCancel(item)">
              <button class="plv-ia-lottery-card-item-btn plv-ia-lottery-card-item-btn--cancel">{{ t('plvIA.lottery.cancelDraw') }}</button>
            </Confirm>
            <Confirm v-else-if="isShowsEndBtn(item)" :lang="lang"  @confirm="lotteryEnd(item)">
              <button class="plv-ia-lottery-card-item-btn plv-ia-lottery-card-item-btn--end">{{ t('plvIA.lottery.endDraw') }}</button>
            </Confirm>
            <button v-else class="plv-ia-lottery-card-item-btn plv-ia-lottery-card-item-btn--result" @click="$emit('change-page', {page: 'lotteryResult', lotteryRecord: item})">{{ t('plvIA.lottery.viewResults') }}</button>
          </div>
        </div>
      </div>
    </div>

    <div class="plv-ia__lottery-btn-group">
      <button class="plv-ia-lottery-btn" @click="continueLottery">
        {{ t('plvIA.lottery.continue') }}
      </button>
    </div>
  </div>

</template>
<script>
import Locale from '@/mixins/locale';
import { formatDate } from '@polyv/utils/src/date';
import Countdown from './component/Countdown';
import Confirm from './component/Confirm';
export default {
  name: 'LotteryCardList',
  mixins: [Locale],
  components: {
    Countdown,
    Confirm
  },
  props: {
    core: {
      type: Object,
      default: () => {
        return {};
      }
    },
    // 抽奖卡片列表
    lotteryCardList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    // 抽奖中列表
    lotteryingStatus: Object
  },
  data() {
    return {
    };
  },
  methods: {
    waitCountdownFinish() {
      this.$emit('reset-lottery-card-list');
    },
    countdownFinish(item, status) {
      item.status = status;
    },
    formatData(val) {
      return formatDate(new Date(val), 'YYYY-MM-DD hh:mm');
    },
    // 显示结束抽奖按钮
    isShowsEndBtn(item) {
      // 抽奖状态，wait未开始、start进行中、end已结束、lottery已开奖 、finish已完成 、cancel已取消
      // 特殊处理 判断无条件抽奖 显示结束按钮
      const status = item.conditionType === 'none' && (item.status === 'end' || item.status === 'lottery');
      return item.status === 'start' || status;
    },
    continueLottery() {
      this.$emit('continue-lottery');
    },
    async lotteryEnd(item) {
      try {
        await this.core.lotteryEnd(item.lotteryId);
        item.status = 'end';
      } catch (e) {
        this.$iaMessage.default(e.message);
        throw new Error(e);
      }
      this.$emit('change-page', { page: 'lotteryResult', lotteryRecord: item });
    },
    // 监听滚动加载
    scrollLoader(e) {
      const target = e.target;
      const onBottom = target.scrollHeight - target.clientHeight - target.scrollTop;
      if (onBottom < 30) this.$emit('scroll-loader');
    },

    conditionTypeMean(type) {
      let str;
      switch (type) {
        case 'invite': str = this.t('plvIA.lottery.conditionInvite'); break;
        case 'duration': str = this.t('plvIA.lottery.conditionDuration'); break;
        case 'none': str = this.t('plvIA.lottery.conditionNone'); break;
        case 'comment': str = this.t('plvIA.lottery.conditionComment'); break;
        default : str = type;
      }
      return str;
    },

    calcDelay(startCountdown) {
      const countdown = Math.floor(startCountdown);
      let hour = 0;
      let min = 0;
      let second = 0;

      if (countdown > 60) {
        // 是否大于零
        min = Math.floor(countdown / 60); // 分钟
        second = Math.floor(countdown % 60); // 秒
        if (min > 60) {
          hour = Math.floor(min / 60);
          min = Math.floor(min % 60);
        }
      } else if (countdown > 0) {
        second = countdown;
      }
      return {
        hour: hour > 9 ? hour : '0' + hour,
        min: min > 9 ? min : '0' + min,
        second: second > 9 ? second : '0' + second
      };
    },

    async lotteryCancel(item) {
      try {
        await this.core.lotteryCancel(item.lotteryId);
        item.status = 'cancel';
      } catch (e) {
        throw new Error(e);
      }
    }
  }
};
</script>

<style lang="scss">
.plv-ia-lottery-card {
  padding: 24px 16px 0;
  overflow: hidden;
}
.plv-ia-lottery-card-list {
  height: 356px;
  overflow-y: scroll;
}
.plv-ia-lottery-card-list-item + .plv-ia-lottery-card-list-item {
  margin-top: 8px;
}
.plv-ia-lottery-card-list-item {
  padding: 20px 20px 16px 20px;
  display: flex;
  box-sizing: border-box;
  background: #F8F8FB;
  .plv-ia-lottery-card-item-left {
    flex: 1;
    .plv-ia-lottery-card-item-header {
      display: flex;
      align-items: center;
      padding-bottom: 4px;
    }
    .plv-ia-lottery-card-item-status {
      display: inline-block;
      padding: 0 4px;
      height: 18px;
      line-height: 18px;
      border-radius: 2px;
      font-size: 12px;
      margin-right: 4px;
    }
    .plv-ia-lottery-card-item-status--waiting {
      background: #45ACFF;
      color: #FFFFFF;
    }
    .plv-ia-lottery-card-item-status--start {
      background: #FF5722;
      color: #FFFFFF;
    }
    .plv-ia-lottery-card-item-status--end {
      background: #9A9A9A;
      color: #FFFFFF;
    }
    .plv-ia-lottery-card-item-header-title {
      flex: 1;
      display: block;
      width: 360px;
      font-weight: 500;
      font-size: 18px;
      color: #333333;
      height: 22px;
      line-height: 22px;
      padding-right: 20px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .plv-ia-lottery-card-item-msg {
      height: 17px;
      line-height: 17px;
      margin-top: 4px;
      font-weight: 400;
      font-size: 12px;
      color: #546E7A;
    }
  }
  .plv-ia-lottery-card-item-right {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    text-align: right;
    .plv-ia-lottery-card-item-delayTime {
      font-weight: 400;
      font-size: 12px;
      span {
        font-size: 22px;
        color: #3FAAFF;
      }
    }
    .plv-ia-lottery-card-item-duration {
      height: 22px;
      line-height: 22px;
      font-size: 12px;
    }
    .plv-ia-lottery-card-item-control {
      .plv-ia-lottery-card-item-btn {
        margin-left: auto;
        padding: 0 20px;
        line-height: 32px;
        height: 32px;
        border-radius: 18px;
        color: #2196F3;
        background: inherit;
        cursor: pointer;
      }
      button:hover {
        opacity: 0.8;
      }
      .plv-ia-lottery-card-item-btn--cancel {
        border: 1px solid #2196F3;
        color: #2196F3;
        background: inherit;
      }
      .plv-ia-lottery-card-item-btn--end {
        border: 1px solid #ffffff;
        background: #FF5722;
        color: #ffffff;
      }
      .plv-ia-lottery-card-item-btn--result {
        border: 1px solid #ffffff;
        background: #2196f3;
        color: #ffffff;
      }
    }
  }
}
</style>
